import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useState } from 'react';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';

const J: React.FC = () => {
    const { t } = useLang('shp3.J');
    const webpOrJpg = useWebpOrJpg('#shp3-J');
    const [titleHeight, setTitleHeight] = useState(0);
    const [titleHeight2, setTitleHeight2] = useState(0);
    /** 动画 */
    useEffect(() => {
        const dom: HTMLElement | null = document.querySelector(`.shp3-J .item-title-1`);
        const dom2: HTMLElement | null = document.querySelector(`.shp3-J .item-desc-1`);
        setTitleHeight(dom?.offsetHeight || 0);
        setTitleHeight2(dom2?.offsetHeight || 0);
        const title = document?.querySelector('.shp3-J .title');
        const list = document?.querySelector('.shp3-J .list');
        const ani1 = AniContainer.create({
            triggerElement: '.shp3-J .title',
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                list?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    list?.classList.remove('enter');
                }
            },
        });
        return () => {
            ani1.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section className={`${css.section} shp3-J GtmModuleData-section`} id="shp3-J" data-section-id={'shp3-J'} data-section-title={t('title')}>
                <div className="title ani-1">{t('title')}</div>
                <div className="list ani-2">
                    <div className="item">
                        <div className="item-img">
                            <EcoImg
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1759990638101/pc_For%20DIY%20solar.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1759991154847/pc_For.webp',
                                )}
                                h5={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1759048740954/m_For%20DIY%20solar.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1759049116458/m_For.webp',
                                )}
                            />
                        </div>
                        <div className="item-title item-title-1">{t('item1_title')}</div>
                        <div className="item-desc item-desc-1">{t('item1_desc')}</div>
                    </div>
                    <div className="item">
                        <div className="item-img">
                            <EcoImg
                                pc={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1760091338491/pc_Compatible%20with%20Rooftop.jpg',
                                    'https://websiteoss.ecoflow.com/upload/image/1760091380912/pc_Compatible.webp',
                                )}
                                h5={webpOrJpg(
                                    'https://websiteoss.ecoflow.com/upload/image/1761534252900/20251027-110251%20(1).jpeg',
                                    'https://websiteoss.ecoflow.com/upload/image/1761534334584/20251027-110251.webp',
                                )}
                            />
                        </div>
                        <div className="item-title" style={{ minHeight: titleHeight }}>
                            {t.rich('item2_title', {
                                sub: (i: string) => <span className="sub">{i}</span>,
                            })}
                        </div>
                        <div className="item-desc" style={{ minHeight: titleHeight2 }}>
                            {t('item2_desc')}
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default J;
